import DxmlRun from "../DxmlRun"
import DxmlImage from "../DxmlImage"
import * as Constants from "../../../../../utils/constants"
import { useEditorFile } from "../../../../../hooks/useEditorFile";

export default function DxmlSvg({ editorSvg }) {
    const { getKeyById } = useEditorFile();

    // It does not show the Textbox background rectangle
    if (editorSvg.Items?.length === 1 && editorSvg.Items[0].Type === Constants.editorType.svgRectangle && editorSvg.Items[0].IsTextboxBackgroundRectangle) {
        return <></>
    }

    return (
        <svg style={editorSvg.ReactCssStyle} width={editorSvg.Width} height={editorSvg.Height}>
            {editorSvg.Items.map((editorBaseModel) => (
                <SubComponent key={getKeyById(editorBaseModel)} editorBaseModel={editorBaseModel} />
            ))}
        </svg>
    )
}

function SubComponent({ editorBaseModel }) {
    const { getKeyById } = useEditorFile();

    if (editorBaseModel.Type === Constants.editorType.svgLine) {
        return (
            <line style={editorBaseModel.ReactCssStyle} x1={editorBaseModel.X1} y1={editorBaseModel.Y1} x2={editorBaseModel.X2} y2={editorBaseModel.Y2}></line>
        )
    } else if (editorBaseModel.Type === Constants.editorType.svgRectangle) {
        return (
            <rect style={editorBaseModel.ReactCssStyle} x={editorBaseModel.X} y={editorBaseModel.Y} width={editorBaseModel.Width} height={editorBaseModel.Height}></rect>
        )
    } else if (editorBaseModel.Type === Constants.editorType.svgPath) {
        return (
            <path style={editorBaseModel.ReactCssStyle} x={editorBaseModel.X} y={editorBaseModel.Y} width={editorBaseModel.Width} height={editorBaseModel.Height} d={editorBaseModel.D}></path>
        )
    } else if (editorBaseModel.Type === Constants.editorType.svgImage) {
        return (
            <foreignObject style={editorBaseModel.ReactCssStyle} x={editorBaseModel.X} y={editorBaseModel.Y} width={editorBaseModel.Width} height={editorBaseModel.Height}>
                <DxmlImage editorImage={editorBaseModel.EditorImage} />
            </foreignObject>
        )
    } else if (editorBaseModel.Type === Constants.editorType.svgText) {
        return (
            <text style={editorBaseModel.ReactCssStyle} x={editorBaseModel.X} y={editorBaseModel.Y} transform={editorBaseModel.Transform}>
                {editorBaseModel.Items.map((editorRun) => (
                    <DxmlRun key={getKeyById(editorRun)} editorRun={editorRun} inForm={true} />
                ))}
            </text>
        )
    }
    return <></>
}